export const baseOrderOptions = [
  { value: 'create_desc', label: 'Creación: más recientes primero' },
  { value: 'create_asc', label: 'Creación: más antiguos primero' },
  { value: 'update_desc', label: 'Actualización: más recientes primero' },
  { value: 'update_asc', label: 'Actualización: más antiguos primero' }
]
